// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1Wvxs","buttons":"SendReceipts_buttons__sJzN7","email":"SendReceipts_email__2GkMW","bookApptTitle":"SendReceipts_bookApptTitle__2bVqC"};